import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './InxmailRegistrationApp.vue';
// import { routes } from './routes';
// import { store } from './store/store';



window.Apps = window.Apps || {};
Apps.initInxmailRegistration = function (glassItemData, initialTranslations, consentUrl) {
    if ($('#inx-reg-app-' + glassItemData.id).length > 0) {
        Vue.use(VueRouter);
        // const router = new VueRouter({
        //     routes
        // });


        var data = {
            glassItemData,
            initialTranslations,
            consentUrl
        }
        new Vue({
            el: '#inx-reg-app-' + glassItemData.id,
            data,
            render: h => h(App)
        })
    }
}